import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminLayoutRoutes } from './admin-layout.routing';
import { DashboardComponent } from './../../components/dashboard/dashboard.component';
import { HomesliderComponent } from './../../dashboard-component/homeslider/homeslider.component';
import { OrderListComponent } from './../../dashboard-component/order-list/order-list.component';
import { FeatursComponent } from './../../dashboard-component/featurs/featurs.component';
import { PastEventsComponent } from './../../dashboard-component/past-events/past-events.component';

import {
  MatButtonModule,
  MatInputModule,
  MatRippleModule,
  MatFormFieldModule,
  MatTooltipModule,
  MatSelectModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatProgressBarModule,
} from '@angular/material';


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(AdminLayoutRoutes),
    FormsModule,
    ReactiveFormsModule,
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule
  ],
  declarations: [
    DashboardComponent,
    HomesliderComponent,
    OrderListComponent,
    FeatursComponent,
    PastEventsComponent
  ]
})

export class AdminLayoutModule {}
